import {
  all, call, put, takeLatest,
} from '@redux-saga/core/effects';
import qs from 'qs';
import PlayerPerformanceActionType from 'actions/playerPerformance/playerPerformanceActionType';
import NetworkService from 'services/networkService';
import {
  changeTransactionLoadingState,
  savePlayersAggregations,
} from 'actions/playerPerformance/playerPerformanceActionCreator';
import { changeLoadingState, changeGenerateReportEndedStatus, setErrorMessage } from 'app/settings/slices';
import { AppConstants } from 'constants/index';
import { getError } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* getPlayersAggregations({ payload }) {
  try {
    const { params } = payload;
    const options = {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    };
    yield put(changeTransactionLoadingState(true));
    const { ReportingAdmin, Aggregation } = AppConstants.api;
    const { data } = yield call(NetworkService.makeAPIGetRequest, [ReportingAdmin, Aggregation], options);
    yield put(savePlayersAggregations(data));
    yield put(changeTransactionLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeTransactionLoadingState(false));
  }
}

function* generatePlayersAggregationsReport({ payload }) {
  try {
    const { params } = payload;
    const options = {
      params,
      paramsSerializer: (param) => qs.stringify(param, { allowDots: true }),
    };
    yield put(changeLoadingState(true));
    const { ReportingAdmin, Aggregation, Generate } = AppConstants.api;
    yield call(NetworkService.makeAPIGetRequest, [ReportingAdmin, Aggregation, Generate], options);
    yield put(changeGenerateReportEndedStatus(true));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* playerPerformanceSaga() {
  yield all([
    takeLatest(PlayerPerformanceActionType.GET_PLAYERS_AGGREGATIONS, getPlayersAggregations),
    takeLatest(PlayerPerformanceActionType.GENERATE_PLAYERS_AGGREGATIONS_REPORT, generatePlayersAggregationsReport),
  ]);
}
